import React from 'react';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationCard from './components/RegistrationCard';
import SecurityBadges from './components/SecurityBadges';

const RegistrationScreen = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <RegistrationHeader />

      {/* Main Content */}
      <main className="pt-16 pb-8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center min-h-[calc(100vh-4rem)]">
            {/* Registration Card */}
            <div className="w-full max-w-md">
              <RegistrationCard />
              
              {/* Security Badges */}
              <SecurityBadges />
            </div>
          </div>
        </div>
      </main>

      {/* Background Pattern */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full opacity-5">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-accent rounded-full blur-3xl" />
        </div>
      </div>
    </div>
  );
};

export default RegistrationScreen;